import { setStep } from "../../redux/payment/slice";
import { PAYMENT_STEPS } from "../../types/PaymentMethodsTypes";

const redirectPost = (data) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = data.redirectUrl;
  form.target = "_self";

  data.parameters.forEach(({ name, value }) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = String(name);
    input.value = String(value ?? "");
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

export const redirectToUrlAndPost = async (dataKey, data, dispatch) => {
  if (data.redirectUrl) {
    redirectPost(data);
  } else {
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};
